import EngagementFilter from "../../components/filters/EngagementFilter/EngagementFilter";
import EngagementFilterResult from "../../components/filters/EngagementFilter/EngagementFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindEngagementFilter from "./EngagementFilter";

export const engagementDefinition = defineDescriptionFilter({
    key: "engagement",
    apiCategory: leadsFilterApiCategory.engagement,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Engagement",
    titleKey: { key: "si.lead_gen_filters.group.engagement.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.engagement.tooltip" },
        filter: new FindEngagementFilter({
            options: description.bucketsDescription.engagement,
        }),
        filterView: EngagementFilter,
        filterResultView: EngagementFilterResult,
    }),
});
